// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { AuthData } from '../model';

@Injectable()
export class AuthService {
  readonly STORAGE_ACCESS_TOKEN_KEY = 'access_token';
  readonly STORAGE_REFRESH_TOKEN_KEY = 'refresh_token';

  authorize(authData: AuthData) {
    this.setAccessToken(authData.access_token);
    this.setRefreshToken(authData.refresh_token);
  }

  isLoggedIn() {
    return !!this.getAccessToken();
  }

  getAccessToken() {
    return localStorage.getItem(this.STORAGE_ACCESS_TOKEN_KEY);
  }

  getRefreshToken() {
    return localStorage.getItem(this.STORAGE_REFRESH_TOKEN_KEY);
  }

  clearTokens() {
    localStorage.removeItem(this.STORAGE_ACCESS_TOKEN_KEY);
    localStorage.removeItem(this.STORAGE_REFRESH_TOKEN_KEY);
  }

  private setRefreshToken(token) {
    localStorage.setItem(this.STORAGE_REFRESH_TOKEN_KEY, token);
  }

  private setAccessToken(token) {
    localStorage.setItem(this.STORAGE_ACCESS_TOKEN_KEY, token);
  }

}
